import React from 'react';
import { toast } from 'react-toastify';
import { MODULE_EVENT, moduleMessageId } from '../../helpers/traceability/modulePorts';
import './boardModules.scss';

// Lo que tarda en irse solo: es un aviso de algo que el usuario acaba de hacer.
const AUTO_CLOSE_MS = 4000;

const ICONS = {
  [MODULE_EVENT.CONNECTED]: '/images/traceability/toast-check.svg',
  [MODULE_EVENT.DISCONNECTED]: '/images/traceability/toast-info.svg',
};

const MESSAGES = {
  [MODULE_EVENT.CONNECTED]: 'blocks.blockly.boardModules.connected',
  [MODULE_EVENT.DISCONNECTED]: 'blocks.blockly.boardModules.disconnected',
};

/**
 * Muestra el toast de un evento de moduleEvents: verde al conectar, celeste al
 * desconectar. Va en el contenedor 'E', el centrado de abajo, como los toasts
 * nuevos de la app.
 *
 * `intl` se recibe y no se toma del contexto porque el toast se arma fuera del
 * árbol de React del componente que lo pide.
 */
const showModuleToast = (intl, { type, label, reading }) => {
  const messageId = moduleMessageId(reading);
  const module = intl.formatMessage({ id: messageId || 'blocks.blockly.boardModules.unknownModule' });
  const message = intl.formatMessage({ id: MESSAGES[type] }, { module, port: label });

  toast(
    <div className={`moduleToastContent is-${type}`}>
      <span className="icon"><img src={ICONS[type]} alt="" /></span>
      <span className="message">{message}</span>
    </div>,
    {
      containerId: 'E',
      position: toast.POSITION.BOTTOM_CENTER,
      className: 'moduleToast',
      closeButton: false,
      hideProgressBar: true,
      autoClose: AUTO_CLOSE_MS,
    },
  );
};

export default showModuleToast;
